<ng-container *ngIf="showPopup && currentFlyer as flyer">
  <dialog
    #popupDialog
    class="flyer-popup-backdrop"
    [class.is-closing]="isClosing"
    aria-modal="true"
    aria-labelledby="flyer-popup-title"
    tabindex="-1"
    (cancel)="onDialogCancel($event)"
  >
    <article
      class="flyer-popup"
      [class.is-closing]="isClosing"
      (mouseenter)="onMouseEnter()"
      (mouseleave)="onMouseLeave()"
      (focusin)="onFocusIn()"
      (focusout)="onFocusOut()"
    >
      <h2 id="flyer-popup-title" class="flyer-popup-title">
        Flyers informativos
      </h2>

      <button
        type="button"
        class="flyer-popup-close"
        aria-label="Cerrar flyer"
        title="Cerrar"
        (click)="close('close-button')"
      >
        <span aria-hidden="true">&times;</span>
      </button>

      <div
        class="flyer-popup-stage"
        [class.is-changing]="isSlideChanging"
        [class.is-loading]="shouldReserveImageSpace"
        (pointerdown)="onPointerDown($event)"
        (pointerup)="onPointerUp($event)"
        (pointercancel)="onPointerCancel()"
      >
        <div
          *ngIf="showBlurBackground && displayImageUrl"
          class="flyer-popup-blur-bg"
          [style.background-image]="backgroundImageStyle"
          aria-hidden="true"
        ></div>

        <div
          *ngIf="isImageLoading"
          class="flyer-popup-skeleton"
          aria-hidden="true"
        ></div>

        <img
          *ngIf="displayImageUrl && !isImageError"
          class="flyer-popup-image"
          [class.is-loaded]="imageState === 'loaded'"
          [class.is-changing]="isSlideChanging"
          [src]="displayImageUrl"
          [alt]="flyer.alt"
          loading="eager"
          draggable="false"
          (load)="onImageLoad()"
          (error)="onImageError()"
        />

        <div *ngIf="isImageError" class="flyer-popup-empty">
          <i class="bi bi-image" aria-hidden="true"></i>
          <span>No se pudo cargar el flyer</span>
        </div>
      </div>

      <footer
        *ngIf="hasMultipleFlyers"
        class="flyer-popup-controls"
        aria-label="Controles del carrusel"
      >
        <button
          type="button"
          class="flyer-popup-nav"
          aria-label="Flyer anterior"
          [disabled]="isSlideChanging"
          (click)="goPrevious('arrow')"
        >
          <span aria-hidden="true">‹</span>
        </button>

        <div class="flyer-popup-status" aria-live="polite">
          <span class="flyer-popup-counter">
            {{ activeIndex + 1 }} / {{ flyers.length }}
          </span>

          <div class="flyer-popup-dots" aria-label="Indicadores">
            <button
              *ngFor="let item of flyers; let index = index; trackBy: trackByFlyer"
              type="button"
              class="flyer-popup-dot"
              [class.is-active]="index === activeIndex"
              [class.has-progress]="showActiveAutoplayProgress && index === activeIndex"
              [attr.aria-current]="index === activeIndex ? 'true' : null"
              [attr.aria-label]="'Ir al flyer ' + (index + 1)"
              (click)="onIndicatorClick(index)"
            >
              <span
                *ngIf="showActiveAutoplayProgress && index === activeIndex"
                class="flyer-popup-dot-progress"
                [style.animation-duration.ms]="autoplayProgressDurationMs"
                [style.animation-play-state]="autoplayProgressAnimationState"
                aria-hidden="true"
              ></span>
            </button>
          </div>
        </div>

        <button
          type="button"
          class="flyer-popup-nav"
          aria-label="Siguiente flyer"
          [disabled]="isSlideChanging"
          (click)="goNext('arrow')"
        >
          <span aria-hidden="true">›</span>
        </button>
      </footer>
    </article>
  </dialog>
</ng-container>
